import React, { Suspense } from "react";
import { Helmet } from "react-helmet";
import { Text, Heading, Img, Button } from "components/new-landing-page";
import Header from "components/new-landing-page/Header";
import MetaInfoDisplay from "components/new-landing-page/MetaInfoDisplay";
import MultilingualPlatformInspiration from "components/new-landing-page/MultilingualPlatformInspiration";
import ParticlesBackground from "components/new-landing-page/ParticlesBackground";
import CarouselTitle from "components/new-landing-page/Carousel";
import { ImgComponent } from "components/Img/ImgComponent";

const inspirationList = [
  {
    inspirationText: (
      <span className="font-normal">
        Inspired by <span className="font-semibold">PM Modi's</span>
        <br /> vision for{" "}
        <span className="font-semibold">
          multilingual <br />
          platform
        </span>
      </span>
    ),
    type: "inspiredBy",
  },
  {
    inspirationText: (
      <span className="font-normal">
        Boost revenue up to{" "}
        <span className="font-semibold">
          2.5 L<br /> to 2.5 Cr
        </span>
        <br />
        <span className="text-md text-indigo-a700 font-semibold underline">
          Learn More
        </span>
      </span>
    ),
    type: "boostRevenue",
  },
  {
    inspirationText: (
      <span className="font-normal">
        India's first{" "}
        <span className="font-semibold">
          educational
          <br /> business ecosystem
        </span>
        <br />
        <span className="text-md text-indigo-a700 font-semibold underline">
          Learn More
        </span>
      </span>
    ),
    type: "businessEcosystem",
  },
  {
    inspirationText: (
      <span className="font-normal">
        Traditional software can
        <br /> cost up to{" "}
        <span className="font-semibold">
          ₹25 lakh in
          <br /> losses
        </span>{" "}
        <span className="text-md text-indigo-a700 font-semibold underline">
          Risk Calculator
        </span>
      </span>
    ),
    type: "traditionalSoftware",
  },
];
const partnerList = [
  { imageSrc: "/images/new-landing-page/img_group.png", metaText: "Meta" },
  {
    imageSrc: "/images/new-landing-page/img_logo_google.svg",
    metaText: "Google",
  },
  { imageSrc: "/images/new-landing-page/startupindia.png", metaText: "" },
];

export default function NewLandingPage() {
  return (
    <div
      style={{
        position: "relative",
        zIndex: 1,
        backgroundColor: "transparent",
      }}
    >
      <ParticlesBackground />
      <Helmet>
        <title>
          Boost Your Institution&#39;s Revenue with India&#39;s First
          Educational Ecosystem
        </title>
        <meta
          name="description"
          content="Join India's premier educational business ecosystem and elevate your institution's revenue potential. Inspired by PM Modi's vision, we offer a multilingual platform supported by industry giants like Microsoft, Meta, and Google. Register now to avail services worth ₹5 lakhs for free and learn how to boost your revenue from ₹2.5L to ₹2.5Cr."
        />
      </Helmet>
      <div
        style={{ backgroundColor: "transparent" }}
        className="h-screen flex flex-col justify-between items-center gap-9 bg-gray-100_01"
      >
        <Header />
        <div className="flex flex-col items-center gap-6 px-14 md:px-5">
          <div className="flex flex-col items-center gap-0.5">
            <Heading
              size="headingmd2"
              as="h1"
              className="!font-schibstedgrotesk text-[50px] font-semibold capitalize tracking-[-1.68px] !text-gray-900 md:text-[48px] sm:text-[22px] md:text-center"
            >
              We help educational institutions
            </Heading>
            <CarouselTitle />
          </div>
          <Heading
            size="textmd"
            as="h3"
            className="text-[20px] font-medium !text-gray-800 sm:text-[16px]"
          >
            Avail <span className="text-black-900">5 Lakhs worth</span> service
            for <span className="text-black-900">free</span>
          </Heading>
          <Button
            color="gradient"
            size="md"
            shape="round"
            className="min-w-[158px] rounded-[24px] px-[26px] sm:px-5"
          >
            Register Now
          </Button>
        </div>
        <div className="mx-20 sm:mx-2">
          <div className="flex flex-col gap-6">
            <div className="grid gap-5 sm:grid-cols-1 md:grid-cols-2 grid-cols-4">
              <Suspense fallback={<div>Loading feed...</div>}>
                {inspirationList.map((d, index) => (
                  <MultilingualPlatformInspiration
                    {...d}
                    key={"listinspiredbyp" + index}
                  />
                ))}
              </Suspense>
            </div>
            <div className="flex items-center bg-gray-100_01 py-1 md:flex-col md:gap-4">
              <div className="flex w-[36%] items-center md:w-full md:px-5 md:justify-center md:w-[100%]">
                <Text as="p" className="text-[16px] font-normal">
                  Funded by
                </Text>
                <div className="ml-2 h-[30px] w-px bg-blue_gray-100_01" />
                <div className="flex gap-2 px-1.5">
                  <ImgComponent
                    src="/images/new-landing-page/img_capa_1.svg"
                    alt="Capaone"
                    className="h-[24px]"
                  />
                  <Heading
                    size="headingmd"
                    as="h4"
                    className="text-[18px] font-semibold"
                  >
                    Microsoft{" "}
                  </Heading>
                </div>
              </div>
              <div className="flex flex-1 items-center justify-end md:self-stretch md:px-5 sm:flex-col sm:mt-2 sm:gap-4 md:justify-center">
                <Text as="p" className="text-[16px] font-normal md:text-center">
                  Collaboration with
                </Text>
                <div className="ml-2 h-[30px] w-px bg-blue_gray-100_01 sm:ml-0 sm:h-px sm:w-[30px] sm:hidden" />
                <div className="ml-1.5 flex gap-5 self-center md:flex-row sm:ml-0 sm:w-full sm:flex-col sm:items-center">
                  <Suspense fallback={<div>Loading feed...</div>}>
                    {partnerList.map((d, index) => (
                      <MetaInfoDisplay {...d} key={"listmetaOne" + index} />
                    ))}
                  </Suspense>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
